export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8285.907be565.jpg";